import styled from "styled-components";
import COLORS from "utils/constants/COLORS";
import React from "react";

export const BaseButton = styled.button`
  border: none;
  outline: none;
  width: 100%;
  color: ${(props) => props.textColor || COLORS.primary};
  background-color: ${(props) => props.bgColor || "white"};
  height: 60px;
  font-size: 20px;
  text-transform: uppercase;
  cursor: pointer;
  font-family: "Futura-Medium", Arial, Helvetica, sans-serif;
`;

const EmisionFooterBarButtons = ({
  onClickAtras,
  labelAtras,
  onClickGuardar,
  labelGuardar = "GUARDAR",
  onClickContinuar,
  labelContinuar = "CONTINUAR",
}) => {
  return (
    <span className='p-buttonset' style={{ width: "100%" }}>
      <div className='row justify-content-center'>
        <div className='col-12 col-md-9 my-auto bg-white'>
          <h6 className='ml-2 py-2 text-center' style={{ fontSize: "20px" }}>
            Recuerda que al dar click en guardar, tu información quedará almacenada y
            podrás cerrar la ventana en cualquier momento para continuar después
          </h6>
        </div>
      </div>
      <div className='row justify-content-center'>
        {labelAtras && (
          <div
            className='col-12 col-md-3 my-auto bg-white py-2'
            // style={{ border: `1px solid ${COLORS.primary}` }}
          >
            <BaseButton
              type='button'
              textColor='white'
              bgColor={COLORS.primary}
              onClick={onClickAtras}>
              {labelAtras}
            </BaseButton>
          </div>
        )}
        <div
          className='col-12 col-md-3 my-auto bg-white py-2'
          // style={{ border: `1px solid ${COLORS.primary}` }}
        >
          <BaseButton
            type='button'
            textColor='white'
            bgColor={COLORS.primary}
            onClick={onClickGuardar}>
            <i
              className='pi pi-save'
              style={{ position: "relative", top: "2px", fontSize: "1.4rem" }}
            />{" "}
            {labelGuardar}
          </BaseButton>
        </div>

        <div className='col-12 col-md-3 my-auto py-2'>
          <BaseButton
            textColor='white'
            bgColor={COLORS.primary}
            onClick={onClickContinuar}>
            {labelContinuar}
          </BaseButton>
        </div>
      </div>
    </span>
  );
};

export default EmisionFooterBarButtons;
